import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IEntityApiService } from 'app/projects/entity/src/lib/interfaces/entity.service.interface';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPerformancePeriodQuery } from '../interfaces/performance-period.query.interface';
import { PerformancePeriodCommand } from '../models/performance-period.command.model';
import { PerformancePeriod } from '../models/performance-period.model';
import { IPaginatedResponse } from 'app/projects/subentity/src/lib/interfaces/paginated-response.interface';
import { ICreatePerformancePeriodActionPayload } from '../interfaces/create-performance-period.action.payload.interface';

@Injectable()
export class PerformancePeriodApiService extends EntityService<IPerformancePeriodQuery, PerformancePeriodCommand> implements IEntityApiService<PerformancePeriod> {
    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment) {
        super(http, environment.apiUrl, 'admin/performance-periods');
    }

    getAll(): Observable<PerformancePeriod[]> {
        return this._getAll().pipe(map((queries) => queries.map((query) => new PerformancePeriod(query))));
    }

    create(entity: ICreatePerformancePeriodActionPayload): Observable<PerformancePeriod> {
        const data = new PerformancePeriodCommand(entity);

        return this._create(data).pipe(map((query) => new PerformancePeriod(query)));
    }

    read(id: string): Observable<PerformancePeriod> {
        return this._read(id).pipe(map((query) => new PerformancePeriod(query)));
    }

    update(entity: PerformancePeriod): Observable<PerformancePeriod> {
        const data = new PerformancePeriodCommand(entity);

        return this._update(entity.id, data).pipe(map((query) => new PerformancePeriod(query)));
    }

    delete(id: string): Observable<any> {
        return this._delete(id);
    }

    getAllPerformancePeriods(pageSize = 5, pageIndex = 1, sortBy = ''): Observable<IPaginatedResponse<IPerformancePeriodQuery>> {
        let params = new HttpParams().set('page', pageIndex.toString()).set('limit', pageSize.toString());

        if (sortBy) {
            params = params.set('sortBy', sortBy);
        }

        return this.http.get<IPaginatedResponse<IPerformancePeriodQuery>>(`${this.environment.apiUrl}/performance-periods`, { params });
    }
}
